import { notification, Switch } from 'antd';
import React, { useContext, useState } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { axiosInstance } from '../config';
import Loader from '../../common/Loader';
import { ServicesContext } from '../../Reusable/ServiceContextmain';

const ContactSection = () => {
  const today = new Date();
  // Format the date to YYYY-MM-DDTHH:MM for the datetime-local input
  const minDateTime = today.toISOString().slice(0, 16);

  const [sideMenu, setSideMenu] = useState(false);
  const { services, loading, error } = useContext(ServicesContext);
  const [isTenderQuery, setIsTenderQuery] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    datetime: '',
    servicename: '',
    message: '',
    noOfProperties: '',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: '',
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required.';
    if (!formData.email) {
      newErrors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid.';
    }
    if (!formData.datetime) newErrors.datetime = 'Date and time are required.';
    if (!formData.phone) newErrors.phone = 'Phone number is required.';
    if (formData.servicename === 'Your Service')
      newErrors.servicename = 'Please select a service.';
    if (!formData.message) newErrors.message = 'Message is required.';

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    } else {
      setLoading(true);
      try {
        const EnquiryData = {
          ...formData,
          tendercontract: isTenderQuery ? 1 : 0,
        };

        const response = await axiosInstance.post(`/inquiry/add`, EnquiryData);
        if (response?.data?.success) {
          setSideMenu(false);
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-20">
                  <i
                    className="bi bi-check2-circle text-success"
                    style={{ fontSize: '20px' }}
                  ></i>
                </div>
                <div>Enquiry Submitted Successfully</div>
              </div>
            ),
            description: 'You can expect a call in 24 hours from our team.',
          });
          setLoading(false);
        } else {
          setSideMenu(false);
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-20">
                  <i
                    className="bi bi-exclamation-circle-fill text-danger"
                    style={{ fontSize: '20px' }}
                  ></i>
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
            description: 'Try Again !',
          });
        }
      } catch (e) {
        setLoading(false);
      }
    }
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      datetime: '',
      servicename: '',
      message: '',
      noOfProperties: '',
    });
  };

  const handleSwitchChange = (checked) => {
    setIsTenderQuery(checked); // Update the state based on the switch value
  };

  return (
    <>
      {Loading && <Loader />}
      <div className="rs-contact contact-style2 py-5">
        <div className="container py-md-5">
          <div className="row no-gutters">
            <div className="col-lg-8">
              <div className="contact-section">
                <div className="sec-title mb-33">
                  <span className="sub-text green-color">Contact Us</span>
                  <h2 className="title">Get In Touch</h2>
                </div>
                <div className="contact-wrap">
                  <form id="contact-form" onSubmit={handleSubmit}>
                    <fieldset>
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 mb-30">
                          <input
                            className={`from-control ${errors.name ? 'is-invalid' : ''}`}
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Name"
                            value={formData.name}
                            onChange={handleChange}
                            // required
                          />
                          {errors.name && (
                            <div className="invalid-feedback ps-2">
                              * {errors.name}
                            </div>
                          )}
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 mb-30">
                          <input
                            className={`from-control ${errors.email ? 'is-invalid' : ''}`}
                            type="email"
                            id="email"
                            name="email"
                            placeholder="E-Mail"
                            value={formData.email}
                            onChange={handleChange}
                            // required
                          />
                          {errors.email && (
                            <div className="invalid-feedback ps-2">
                              * {errors.email}
                            </div>
                          )}
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 mb-30 ">
                          <input
                            className="from-control date"
                            type="datetime-local"
                            placeholder="Date"
                            name="datetime"
                            value={formData.datetime}
                            onChange={handleChange}
                            min={minDateTime}
                          />
                          <br className="d-block d-xl-none" />
                          {errors.datetime && (
                            <span
                              className="text-danger ps-2"
                              style={{ fontSize: '14px' }}
                            >
                              * {errors.datetime}
                            </span>
                          )}
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 mb-30">
                          <input
                            className={`from-control ${errors.phone ? 'is-invalid' : ''}`}
                            type="text"
                            id="phone"
                            name="phone"
                            placeholder="Phone Number"
                            value={formData.phone}
                            onChange={handleChange}
                            maxLength={11}
                            // required
                          />
                          {errors.phone && (
                            <div className="invalid-feedback ps-2">
                              * {errors.phone}
                            </div>
                          )}
                        </div>
                        <div className="col-12 mb-3">
                          <select
                            name="servicename"
                            className="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                            value={formData.servicename}
                            onChange={handleChange}
                          >
                            <option value="">Select a Service</option>
                            {services?.map((item) => (
                              <option value={item?.id}>{item?.name}</option>
                            ))}
                          </select>
                          {errors.servicename && (
                            <span
                              className="text-danger ps-2"
                              style={{ fontSize: '14px' }}
                            >
                              * {errors.servicename}
                            </span>
                          )}
                        </div>
                        <div className="d-flex justify-content-between">
                          <h6 className="form-Query mb-3">
                            Is This Query For Tender Contract?
                          </h6>
                          <Switch
                            defaultChecked={false}
                            onChange={handleSwitchChange}
                          />
                        </div>
                        {isTenderQuery && (
                          <div className="col-lg-12 mb-3">
                            <input
                              type="number"
                              min={1}
                              className="from-control"
                              id="noOfProperties"
                              name="noOfProperties"
                              placeholder="No. of Properties"
                              value={formData.noOfProperties}
                              onChange={handleChange}
                            />
                          </div>
                        )}
                        <div className="col-lg-12">
                          <textarea
                            className={`from-control ${errors.message ? 'is-invalid' : ''}`}
                            id="message"
                            name="message"
                            placeholder="Your Message"
                            value={formData.message}
                            onChange={handleChange}
                            // required
                          />
                          {errors.message && (
                            <div className="invalid-feedback ps-2">
                              * {errors.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="btn-part mt-5">
                        <div className="form-group mb-0">
                          <p className="submit-btn submit-btn2">
                            <span className="arrow-btn">
                              <input type="submit" value="Submit Now" />
                            </span>
                          </p>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-info-box">
                <div className="sec-title pb-5">
                  <h2 className="title mb-4">Contact Info</h2>
                </div>
                <div className="address-item mb-5 mt-5">
                  <div className="address-icon">
                    <i className="bi bi-geo-alt" />
                  </div>
                  <div className="address-text">
                    <span className="label">4 Rivers Street</span>
                    <span className="des">
                      Leicester, England, LE3 5RX
                      <br />
                      United Kingdom.
                    </span>
                  </div>
                </div>
                <div className="address-item mb-5">
                  <div className="address-icon">
                    <i className="bi bi-envelope-open" />
                  </div>
                  <div className="address-text">
                    <span className="label">Mail Us</span>
                    <a href="mailto:info@precisioncontractservices.com">
                      info@precisioncontractservices.com
                    </a>
                    <br />
                  </div>
                </div>
                <div className="address-item">
                  <div className="address-icon">
                    <i className="bi bi-telephone-inbound" />
                  </div>
                  <div className="address-text">
                    <span className="label">Telephone</span>
                    <a href="tel:01162102688">01162102688</a>
                    <br />
                    <a href="tel:07380851496">07380851496</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactSection;
